import React, { FC } from "react";
import { UiArrowProps } from "./types";

const UiArrow: FC<UiArrowProps> = ({
  className,
  onClick,
  icon,
  visibility,
}) => {
  return (
    <button
      className={className}
      onClick={onClick}
      style={{
        visibility: visibility,
      }}
    >
      <figure className={icon} />
    </button>
  );
};

export default UiArrow;
